import { render, staticRenderFns } from "./DrawIndex.vue?vue&type=template&id=47919c95&scoped=true&"
import script from "./DrawIndex.vue?vue&type=script&lang=js&"
export * from "./DrawIndex.vue?vue&type=script&lang=js&"
import style0 from "./DrawIndex.vue?vue&type=style&index=0&id=47919c95&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47919c95",
  null
  
)

export default component.exports